import { render } from "./CropForm.vue?vue&type=template&id=48ac4148"
import script from "./CropForm.vue?vue&type=script&lang=js"
export * from "./CropForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__